import { AloftArea, ConstellationOneListing, isUndefined } from '@aloft/toolkit-shared';
import { Flex } from '@aloft/toolkit-sui';

import MLSDataSimpleStatistic from './MLSDataSimpleStatistic.tsx';
import { getLotAreaSqftString } from './utils/getLotAreaSqftString.ts';

const MLSMajorStatistics = ({ listingData }: { listingData: ConstellationOneListing }) => (
  <Flex width="100%" justifyContent="space-between" marginTop="5px">
    <MLSDataSimpleStatistic
      value={
        isUndefined(listingData.LivingArea)
          ? '-'
          : AloftArea.fromNumber(listingData.LivingArea ?? 0, 'sqft').unitAmount.toLocaleString(
              'en-US',
            )
      }
      label="Sf"
    />
    <MLSDataSimpleStatistic value={listingData.BedroomsTotal?.toString() ?? '-'} label="Beds" />
    <MLSDataSimpleStatistic
      value={listingData.BathroomsTotalInteger?.toString() ?? '-'}
      label="Baths"
    />
    <MLSDataSimpleStatistic value={listingData.YearBuilt?.toString() ?? '-'} label="Built" />
    <MLSDataSimpleStatistic value={getLotAreaSqftString(listingData)} label="Sf Lot" />
  </Flex>
);
export default MLSMajorStatistics;
